import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import CustomTheme from '../assets/themes/theme'
import es from 'vuetify/es5/locale/es'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: CustomTheme.light
        },
        options: { customProperties: true }
    },
    lang :{
        locales: {es},
        current: 'es'
    }
});
